<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-else class="ret-cards-wrapper">
      <div v-if="$canm('assets', 'useOwners')">
        <div class="ret-card-header">
          <p>{{ $t('assets.visibility-owner') }}</p>
        </div>
        <v-card class="ret-card">
          <v-card-text>
            <form>
              <v-select
                v-model="currentOwnerId"
                :label="$t('assets.visibility-owner')"
                :items="['', ...owners]"
                item-text="ancestorsAndThisString"
                item-value="id"
                :menu-props="{bottom: true}"
              ></v-select>
            </form>
          </v-card-text>
        </v-card>
      </div>

      <div>
        <div class="ret-card-header">
          <p>{{ $t('language') }}</p>
        </div>
        <v-card class="ret-card">
          <v-card-text>
            <form>
              <v-select
                v-model="language"
                :items="languages"
                :label="$t('language')"
                @change="saveLanguageDisabled = language === $i18n.locale"
                data-test="language-select"
              ></v-select>
              <v-btn
                color="primary"
                :disabled="saveLanguageDisabled"
                @click="changeLanguage"
                data-test="language-submit-button"
              >{{ $t('save') }}</v-btn>
            </form>
          </v-card-text>
        </v-card>
      </div>

      <div>
        <div class="ret-card-header">
          <p>{{ $t('change-password') }}</p>
        </div>
        <v-card class="ret-card">
          <v-card-text>
            <form>
              <v-text-field
                v-model="item.currentPassword"
                :label="$t('current-password')"
                type="password"
                @input="passwordCheck"
                data-test="current-password"
              ></v-text-field>
              <v-text-field
                v-model="item.password"
                :label="$t('new-password')"
                type="password"
                @input="passwordCheck"
                data-test="new-password"
              ></v-text-field>
              <v-text-field
                v-model="item.passwordConfirmation"
                :label="$t('new-password-again')"
                type="password"
                @input="passwordCheck"
                data-test="new-password-again"
              ></v-text-field>
              <v-btn
                color="primary"
                :disabled="changePasswordDisabled"
                @click="changePassword"
                data-test="change-password"
              >{{ $t('change-password') }}</v-btn>
            </form>
          </v-card-text>
        </v-card>
      </div>

      <div v-if="$can('admin')">
        <div class="ret-card-header">
          <p>{{ $t('computer-name') }}</p>
        </div>
        <v-card class="ret-card">
          <v-card-text>
            <form>
              <v-text-field
                v-model="computerName"
                :label="$t('computer-name')"
                data-test="computer-name"
              ></v-text-field>
              <v-btn
                color="primary"
                :disabled="changeComputerNameDisabled"
                :loading="computerNameLoading"
                @click="changeComputerName"
                data-test="change-computer-name"
              >{{ $t('change-computer-name') }}</v-btn>
            </form>
          </v-card-text>
        </v-card>
      </div>

      <div v-if="$can('admin')">
        <div class="ret-card-header">
          <p>{{ $t('command-token') }}</p>
        </div>
        <v-card class="ret-card">
          <v-card-text>
            <div v-if="commandToken">
              <p>{{ $t('command-token-present') }}</p>
              <v-btn color="accent" @click="destroyCommandToken">{{ $t('destroy-command-token') }}</v-btn>
            </div>
            <div v-else>
              <form>
                <v-text-field
                  v-model="commandTokenPassword"
                  :label="$t('command-token-password')"
                  type="password"
                ></v-text-field>
                <v-btn
                  color="primary"
                  :disabled="commandTokenDisabled"
                  @click="createCommandToken"
                >{{ $t('create-command-token') }}</v-btn>
                <span
                  class="grey--text text--darken-2"
                  v-if="commandTokenPassword && !this.computerCookieName"
                >
                  <v-icon small>info</v-icon>
                  {{ $t('set-computer-name') }}
                </span>
              </form>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <!-- <div v-if="$can('admin')">
        <div class="ret-card-header">
          <p>{{ $t('Developer mode') }}</p>
        </div>
        <v-card class="ret-card">
          <v-card-text>
            <form>
              <v-switch hide-details v-model="developerMode"
              :label="$t('Developer mode')"></v-switch>
              <v-switch hide-details v-model="useDemoDataInVisual"
              :label="$t('Use demo data in visual')"></v-switch>
            </form>
          </v-card-text>
        </v-card>
      </div>-->
    </div>
  </div>
</template>

<script>
import JWT from 'jsonwebtoken'
import Fingerprint from 'fingerprintjs2'
import moment from 'moment-timezone'

export default {
  data: function () {
    return {
      dataLoaded: false,
      language: null,
      saveLanguageDisabled: true,
      item: {
        id: this.$store.state.auth.currentUser.id,
        currentPassword: '',
        password: '',
        passwordConfirmation: ''
      },
      changePasswordDisabled: true,
      commandTokenPassword: '',
      auxModels: [
        { name: 'owners', tree: true }
      ],
      commandToken: JWT.decode(this.$cookies.get('command')),
      computerName: null,
      computerCookieName: null,
      computerNameLoading: false
    }
  },
  created () {
    this.storeUpdate()
    this.refreshComputerName()
    this.language = window.localStorage.getItem('userLanguage')
  },
  computed: {
    languages () {
      return [
        { value: 'cs', text: 'Čeština' },
        { value: 'en', text: 'English' },
        { value: 'fr', text: 'Français' },
        { value: 'pl', text: 'Polski' }
      ]
    },
    developerMode: {
      get () { return this.$store.state.developerMode },
      set (val) {
        this.$store.commit('setFlat', { param: 'developerMode', val: val })
      }
    },
    useDemoDataInVisual: {
      get () { return this.$store.state.useDemoDataInVisual },
      set (val) {
        this.$store.commit('setFlat', { param: 'useDemoDataInVisual', val: val })
      }
    },
    user () {
      return this.$store.state.auth.currentUser
    },
    owners () {
      const sorted = this.$store.state.items['owners'].nodes
      sorted.sort((a, b) => {
        return a.ancestorsAndThisString > b.ancestorsAndThisString
      })
      return sorted
    },
    currentOwnerId: {
      get () { return this.$store.state.auth.currentOwnerId },
      set (val) {
        this.$store.commit('setCurrentOwnerId', val)
      }
    },
    commandTokenDisabled () {
      return !this.commandTokenPassword || !this.computerCookieName
    },
    changeComputerNameDisabled () {
      return !this.computerName || this.computerCookieName === this.computerName
    }
  },
  methods: {
    // Loaders
    async storeUpdate () {
      try {
        await Promise.all([
          // auxes
          this.auxModels.map(model => this.$store.dispatch('getItems', { model }))
        ])
        this.dataLoaded = true
      } catch (error) {
        console.error(error)
      }
    },
    // Actions
    changeLanguage () {
      this.$store.dispatch('updateOwnUser', {
        user: {
          id: this.item.id,
          language: this.language
        }
      })
        .then(() => {
          window.localStorage.setItem('userLanguage', this.language)
          moment.locale(this.language)
          this.saveLanguageDisabled = true
          this.$i18n.locale = this.language
          this.$store.commit('setFlat', { param: 'savedSnackbar', val: true })
        })
        .catch(console.error)
    },
    passwordCheck () {
      const { currentPassword, password, passwordConfirmation } = this.item
      if (currentPassword && password && password === passwordConfirmation) {
        this.changePasswordDisabled = false
      } else {
        this.changePasswordDisabled = true
      }
    },
    changePassword () {
      this.$store.dispatch('updateOwnUser', { user: this.item })
        .then((response) => {
          if (response && response.status >= 200 && response.status <= 299) {
            this.$router.push({ name: 'home' })
          }
        })
    },
    async createCommandToken () {
      const commandPassword = this.commandTokenPassword
      this.commandTokenPassword = null // Empty the form field
      try {
        const fingerprint = await this.getFingerprint()
        const { status, data } = await this.$store.dispatch('createCommandToken', {
          commandPassword,
          fingerprint
        })
        if (status >= 200 && status <= 299) {
          // Saving the JWT command token to cookie
          this.$cookies.set('command', data, Infinity)
          this.refreshCommandToken()
        }
      } catch (error) {
        console.error(error)
      }
    },
    destroyCommandToken () {
      this.$cookies.remove('command')
      this.refreshCommandToken()
    },
    refreshCommandToken () {
      this.commandToken = JWT.decode(this.$cookies.get('command'))
    },
    async changeComputerName () {
      try {
        this.computerNameLoading = true
        // create computer fingerprint
        const hash = await this.getFingerprint()
        // save fingerprint in DB
        await this.$store.dispatch('saveComputerName', {
          name: this.computerName,
          hash
        })
        // set computer name
        this.refreshComputerName()
      } catch (error) {
        console.error(error)
      } finally {
        this.computerNameLoading = false
      }
    },
    async refreshComputerName () {
      const hash = await this.getFingerprint()
      const response = this.$store.dispatch('loadComputerName', {
        hash
      })
      const { data } = await response
      if (data.name) {
        this.computerName = data.name
        this.refreshComputerCookieName(data.name)
      } else {
        console.warn('Computer name not set')
      }
    },
    refreshComputerCookieName (name) {
      this.computerCookieName = this.$cookies
        .set('cmpname', name, Infinity)
        .get('cmpname')
    },
    async getFingerprint () {
      const components = await Fingerprint.getPromise()
      const values = components.map((component) => component.value)
      return Fingerprint.x64hash128(values.join(''), 31)
    }
  }
}
</script>
